import { useState } from "react"
import { Box, CircularProgress } from "@mui/material"
import Typography from "@mui/material/Typography"
import { OutlinedInput } from "@mui/material"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"

import {
    OpportunityModalHeader,
    OpportunityDetailsWrapper,
    OpportunityDetailsSubWrapper,
    OpportunityFields,
    OpportunityMerticField,
    OpportunityMerticFieldOne,
    OpportunityMerticFieldTwo,
    OpportunityMerticDate,
    OpportunityMerticStartDateOne,
    OpportunityMerticEndDateTwo,
    OpportunityButtons,
    ButtonWrapper,
    CancelButton,
    SetButton,
    MenuProps,
    style,
} from "./Atom"

const BucketConfirmation = (props: any) => {

    const {
        open,
        setOpen,
        type,
        newBucket,
        setNewBucket,
        handleBucketAdd,
        editBucket,
        setEditBucket,
        handleBucketUpdate,
    } = props

    const [loading, setLoading] = useState({
        now: false,
        message: false,
    })

    const isDisabled: boolean = type == "new" ? !newBucket?.bucketName?.trim() : (!editBucket?.newBucketName?.trim() || editBucket?.oldBucketName?.trim() == editBucket?.newBucketName?.trim())

    const handleClose = () => {

        type == "new" ? setNewBucket({ bucketName: "" }) : setEditBucket({ oldBucketName: "", newBucketName: "", bucketId: null })


        setOpen(false)
    }

    const handleClickCreate = async () => {

        setLoading({ now: true, message: true })

        await handleBucketAdd(newBucket?.bucketName.trim())

        setLoading({ now: false, message: false })
        handleClose();
    }

    const handleClickUpdate = async () => {

        setLoading({ now: true, message: true })

        await handleBucketUpdate(editBucket?.bucketId, editBucket?.newBucketName?.trim());

        setLoading({ now: false, message: false })
        handleClose();
    }

    const changeHandler = (value: string) => {
        type == "new"
            ?
            setNewBucket({ ...newBucket, bucketName: value })
            :
            setEditBucket({ ...editBucket, newBucketName: value })
    }

    const handleClickSubmit = () => {
        if (type == "new") {
            handleClickCreate()
        } else if (type == "edit") {
            handleClickUpdate()
        } else {
            handleClose()
        }
    }

    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {loading.now ? (
                <Box
                    sx={{
                        ...style,
                        flexDirection: "column",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                    }}
                >
                    <CircularProgress />
                    {loading.message ?
                        type == "new"
                            ?
                            <Typography
                                sx={{
                                    mt: "10px",
                                    mx: "40px",
                                    textAlign: "center",
                                    lineHeight: 2,
                                }}
                            >
                                Creating Bucket with the name <b>{newBucket?.bucketName}</b>
                            </Typography>
                            :
                            <Typography
                                sx={{
                                    mt: "10px",
                                    mx: "40px",
                                    textAlign: "center",
                                    lineHeight: 2,
                                }}
                            >
                                Updating Bucket Name from <b>{editBucket?.oldBucketName}</b> to <b>{editBucket?.newBucketName}</b>
                            </Typography>
                        : <></>}
                </Box>
            ) : (
                <Box sx={style}>

                    <OpportunityModalHeader>
                        <Typography>{type == "new" ? `Create New Bucket` : `Update Bucket Name`}</Typography>
                        <CloseIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleClose()}
                        />
                    </OpportunityModalHeader>

                    <OpportunityDetailsWrapper>
                        <OpportunityDetailsSubWrapper>

                            <OpportunityFields>
                                <OpportunityMerticField>
                                    <OpportunityMerticFieldTwo>
                                        <Typography
                                            fontSize={14}
                                            sx={{
                                                paddingBottom: "7px",
                                            }}
                                        >
                                            Enter New Bucket Name *
                                        </Typography>
                                        <OutlinedInput
                                            autoFocus
                                            sx={{ width: "100%" }}
                                            value={type == "new" ? newBucket?.bucketName : editBucket?.newBucketName}
                                            defaultValue={type == "edit" ? editBucket?.oldBucketName : null}
                                            placeholder={type == "new" ? "New Bucket" : editBucket?.oldBucketName}
                                            onChange={(e: any) => changeHandler(e?.target?.value)}
                                            onKeyDown={(e: any) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    if (!isDisabled) {
                                                        handleClickSubmit();
                                                    }
                                                }
                                            }}
                                        />
                                    </OpportunityMerticFieldTwo>
                                </OpportunityMerticField>

                            </OpportunityFields>
                        </OpportunityDetailsSubWrapper>
                    </OpportunityDetailsWrapper>

                    <OpportunityButtons>
                        <ButtonWrapper>
                            <CancelButton onClick={handleClose}>Cancel</CancelButton>
                            <Box>

                                <SetButton
                                    onClick={() => {
                                        handleClickSubmit()
                                    }}
                                    disabled={isDisabled}
                                >
                                    {type == "new" ?
                                        `Create` : `Edit`}
                                </SetButton>
                            </Box>
                        </ButtonWrapper>
                    </OpportunityButtons>
                </Box>
            )}
        </Modal>
    )
}

export default BucketConfirmation
